import { Icon, Text } from '@yes.technology/react-toolkit'
import {
  ButtonsWrapper,
  Container,
  Divider,
  IconButton,
  MainButton,
  PositionCounter
} from './Media.styles'
import { useEffect } from 'react'

export type MediaProps = {
  currentPosition: number
  total: number
  onNavigateNext: () => void
  onNavigate: (position: number) => void
  intervalTime?: number
  color?: string
  setIsPlaying: (state: boolean) => void
  isPlaying: boolean
}

const DEFAULT_INTERVAL_TIME = 30000

const addZeroToNumber = (number: number) => ('0' + number).slice(-2)

const Media = ({
  currentPosition,
  total,
  onNavigateNext,
  onNavigate,
  color,
  isPlaying,
  setIsPlaying,
  intervalTime = DEFAULT_INTERVAL_TIME
}: MediaProps) => {
  const lastPosition = total - 1

  const togglePlayState = () => {
    if (!isPlaying && currentPosition === lastPosition) {
      onNavigate(0)
    }

    setIsPlaying(!isPlaying)
  }

  useEffect(() => {
    if (!isPlaying) return

    const interval = setInterval(() => {
      onNavigateNext()
    }, intervalTime)

    return () => {
      clearInterval(interval)
    }
  }, [isPlaying, onNavigateNext, intervalTime])

  const navigateToPrev = () => {
    onNavigate(currentPosition === 0 ? lastPosition : currentPosition - 1)
  }

  return (
    <Container>
      <ButtonsWrapper>
        <IconButton onClick={() => onNavigate(0)} color={color}>
          <Icon iconName='Previous' icColor='_006BFF' />
        </IconButton>
        <IconButton onClick={navigateToPrev} color={color}>
          <Icon iconName='PreviousSingleArrow' icColor='_006BFF' />
        </IconButton>
        <MainButton onClick={togglePlayState} color={color}>
          <Icon
            iconName={isPlaying ? 'Pause' : 'Play'}
            icSize='small'
            icColor='white'
          />
        </MainButton>
        <IconButton onClick={onNavigateNext} color={color}>
          <Icon iconName='FowardSingleArrow' icColor='_006BFF' />
        </IconButton>
        <IconButton onClick={() => onNavigate(lastPosition)} color={color}>
          <Icon iconName='Foward' icColor='_006BFF' />
        </IconButton>
      </ButtonsWrapper>
      <Divider />
      <PositionCounter color={color}>
        <Text variant='content-emphasis-07'>
          {addZeroToNumber(currentPosition + 1)}
        </Text>
        <Text variant='content-07'>/{addZeroToNumber(total)}</Text>
      </PositionCounter>
    </Container>
  )
}

export default Media
